import * as React from 'react';

function SvgPropertyListStar(props) {
  return (
    <svg width={12} height={12} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.642 4.138l-2.976-.433-1.33-2.696a.377.377 0 00-.673 0l-1.33 2.696-2.975.433a.374.374 0 00-.207.64l2.153 2.098-.509 2.964a.375.375 0 00.544.395L6 8.835l2.661 1.4a.374.374 0 00.544-.395l-.508-2.964 2.152-2.098a.374.374 0 00-.207-.64z" />
    </svg>
  );
}

export default SvgPropertyListStar;
